module.exports = __webpack_public_path__ + "img/春节大促_18.2828d78a.png";